module.exports = {
  "name": "福水智联开发",
  "short_name": "福水开发",
  "copyright": "福水智联技术有限公司",
  "display": "standalone",
  "start_url": "./?utm_source=homescreen",
  "theme_color": "#1e5588",
  "background_color": "#001529",
  "icons": [
    {
      "src": "/icons/icon-192x192.png",
      "sizes": "192x192"
    },
    {
      "src": "/icons/icon-128x128.png",
      "sizes": "128x128"
    },
    {
      "src": "/icons/icon-512x512.png",
      "sizes": "512x512"
    }
  ],
  "font_size_base": "16px",
  "api_url": "https://sxzx.prajna-iot.cn",
  "images": {
    "favicon": "/favicon.png",
    "login": {
      "background": "/login/login_bg.jpg",
      "title": "/login/login_title.png"
    }
  },
  "logon_expire_days": 365
}
